import React from 'react';
import PropTypes from 'prop-types';
import {observer} from 'mobx-react';

const getSortNameTr = (value, translations, name) => {
  const {price, outboundDuration, returnDuration,
    departureTimeRoute, arrivalTimeRoute} = translations;
  if (value === 'price') {
    return price;
  } else if (value === 'legDuration-0') {
    return `${outboundDuration} ${name}`;
  } else if (value === 'legDuration-1') {
    return `${returnDuration} ${name}`;
  } else if (value.includes('legDepDate')) {
    return departureTimeRoute.replace('{route}', name);
  } else if (value.includes('legArrDate')) {
    return arrivalTimeRoute.replace('{route}', name);
  }
};

const Sorting = ({translations, sorting, setSortingType}) => (
  <div className="ml-auto floating-label floating-label-show">
    <label htmlFor="sel1">{translations.sortingTitle}</label>
    <select
      className="form-control sortingType"
      onChange={(e) => setSortingType(e.target.value)}
    >
      {
        sorting.map(({value, selected, name}, index) => (
          <option key={index} value={value} defaultValue={selected}>
            {getSortNameTr(value, translations, name)}
          </option>
        ))
      }
    </select>
  </div>
);

Sorting.propTypes = {
  sorting: PropTypes.object.isRequired,
  setSortingType: PropTypes.func.isRequired,
  translations: PropTypes.shape({
    sortingTitle: PropTypes.string.isRequired,
    price: PropTypes.string.isRequired,
    outboundDuration: PropTypes.string.isRequired,
    returnDuration: PropTypes.string.isRequired,
    departureTimeRoute: PropTypes.string.isRequired,
    arrivalTimeRoute: PropTypes.string.isRequired
  }).isRequired
};

export default observer(Sorting);
